import "../assest_css/header.css";

const Header = () => {
  return (
    <header id="nav" className="header header-nav sticky">
      <ul>
        <li>
          <a href="/#intro">Home</a>
        </li>
        <li>
          <a href="/#about">About</a>
        </li>
        <li>
          <a href="/#skills">Skills</a>
        </li>
        <li>
          <a href="/#contact">Contact</a>
        </li>
      </ul>
    </header>
  );
};

export default Header;
